<template>
  <div :class="componentClassName">
    <dt class="a-application-summary-item__title">{{ title }}</dt>
    <dd class="a-application-summary-item__description">
      <slot>{{ description }}</slot>
      <a-caption-list v-if="notes">
        <li v-for="(note, index) in notes" :key="index">{{ note }}</li>
      </a-caption-list>
    </dd>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import ACaptionList from '@/components/atoms/caption-list';

export default {
  name: 'a-application-summary-item',
  components: {
    ACaptionList,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: null,
      valiator(value) {
        return value.match(/(null|alphanumeric)/);
      },
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    notes: {
      type: Array,
      default: null,
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-application-summary-item', this.variant);
      return `${baseClassName} ${this.class}`.trim();
    },
  },
};
</script>
